import './design/ripple.js';
import './design/menu.js';
import './design/dialog.js';
import './design/tabs.js';
import './design/snackbar.js';
import './design/progress.js';
import './design/slider.js';
import './design/chips.js';
import './design/drawer.js';
import './design/select.js';
import './design/alert.js';
import './design/pagination.js';
import './design/table-sort.js';
import './design/banner.js';
import './design/appbar.js';
import './design/bottom-sheet.js';
import './design/dropzone.js';
import './design/toast.js';
import './design/popover.js';
import './design/textarea.js';
import './design/theme.js';
import './design/overlay.js';
import './design/form-validate.js';
import './design/avatar.js';
import './design/empty.js';
import './design/stepper.js';
import './design/carousel.js';
import './design/rating.js';
import './design/date-picker.js';
import './design/time-picker.js';
import './design/autocomplete.js';
import './design/tag-input';
import './design/fab-dial';
import './design/nav-rail';
import './design/color-picker';
import './design/tree';
import './design/range-dual';
import './design/table-select';
import './design/appbar-search';

console.log('JS Ready');

// Reveal on scroll
(() => {
    const els = document.querySelectorAll(".reveal");
    if (!els.length) return;

    // Respect accessibilité
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) {
        els.forEach(el => el.classList.add("is-visible"));
        return;
    }

    const io = new IntersectionObserver(
        (entries) => {
            entries.forEach(e => {
                if (e.isIntersecting) {
                    e.target.classList.add("is-visible");
                    io.unobserve(e.target);
                }
            });
        },
        {threshold: 0.12}
    );

    els.forEach(el => io.observe(el));
})();

// File input label (Spec)
(() => {
    const input = document.querySelector("#spec.file__input");
    const nameEl = document.querySelector("#specFileName");
    if (!input || !nameEl) return;

    const update = () => {
        const file = input.files && input.files[0];
        nameEl.textContent = file ? file.name : "Aucun fichier sélectionné";
    };

    input.addEventListener("change", update);
    update();
})();